import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { SpinnerComponent } from '../spinner/spinner.component';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-feedback-text',
    templateUrl: './feedback-text.component.html',
    styleUrls: ['./feedback-text.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgClass, SpinnerComponent]
})
export class FeedbackTextComponent {
    @Input() type: 'error' | 'information' | 'warning' | 'empty' | 'loading' | 'invalid' | 'success';

    constructor() { }

    public isIconAvaliable() {
        if (!this.type || this.type === 'loading' || this.type === 'success') {
            return false;
        }
        return true;
    }

    public getIconName() {
        if (this.type === 'warning') {
            return 'exclamation';
        } else if (this.type === 'error') {
            return 'error';
        } else if (this.type === 'empty') {
            return 'hide_source';
        }
        return 'info';
    }
}
